export default __webpack_public_path__ + "3d9c9824ef36fd4534f5dfd44ef84df8.jpg";